module.exports = __webpack_public_path__ + "icons/original/large/large-f6.d614ae0c9d5efd565ca308cd3435188e.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f6.png
// module id = dSmd
// module chunks = app